<template>
  <ul class="timeline mt-2 mb-2">
    <li
      v-for="option in options"
      :key="option.value"
      :class="['timeline-item', { 'timeline-item-active': isActive(option.value) }]"
      @click.prevent="onClickOption(option)"
    >
      <span />
      <div>
        <p class="timeline-title">{{option.title}}</p>
        <p class="timeline-subtitle">{{option.subtitle}}</p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Timeline',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: [String, Number],

    options: {
      type: Array,
      default: () => ([])
    }
  },

  watch: {
    value(val) {
      this.active = val
    }
  },

  data() {
    return {
      active: this.value
    }
  },

  methods: {
    isActive(option) {
      if (this.active === undefined || this.active === null || this.active === '') {
        return this.options.length > 0 ? this.options[0].value === option : false
      }
      return option === this.active
    },

    onClickOption(option) {
      this.active = option.value
      this.$emit('change', option.value)
    }
  }
}
</script>
